<template>
    <rkm-overlay>
        <rkm-layout-body :title="`Gerenciamento de solicitação`">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>

                <rkm-button
                    :disabled="!$refs.Form || $refs.Form.canFinalize"
                    @click="$refs.Form.finalize()"
                    color="success"
                >
                    Finalizar solicitação
                </rkm-button>

                <rkm-button
                    :disabled="!$refs.Form || $refs.Form.canCancel"
                    @click="$refs.Form.cancel()"
                    color="danger"
                >
                    Cancelar solicitação
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form :id="id" ref="Form" @save="handleSave" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/manutencao/gerenciamento/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

                this.redirectToList()
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'manutencao-gerenciamento-index' })
        }
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>